import React from 'react'
import { cn } from '@/lib/utils'
// import { LabelIcon } from '../icons/label-icon'

const CustomLabel = ({ label, white, className }: { label: string, white?: boolean, className?: string }) => {
    return (
        <h2
            className={cn(
                'text-primary-text font-lexend font-semibold select-none capitalize',
                white && "text-white",
                className ?? "text-2xl md:text-3xl lg:text-3xl lg:leading-snug tracking-wide",
            )}
            // style={{
            //     textShadow: "0px 4px 0px rgba(0, 0, 0, 0.10)",
            //     WebkitTextStrokeWidth: "0.20000000298023224",
            //     WebkitTextStrokeColor: "#fff",
            // }}
        >
            {label}
            {/* <LabelIcon /> */}
        </h2 >
    )
}

export default CustomLabel